import { render, staticRenderFns } from "./PiriodSignVariant.vue?vue&type=template&id=4d4ed32e&scoped=true&"
import script from "./PiriodSignVariant.vue?vue&type=script&lang=js&"
export * from "./PiriodSignVariant.vue?vue&type=script&lang=js&"
import style0 from "./PiriodSignVariant.vue?vue&type=style&index=0&id=4d4ed32e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4ed32e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
